import { z } from 'zod'

export const addressSchema = z.object({
  firstName: z.string().min( 1, `First name is required` ),
  lastName: z.string().min( 1, `Last name is required` ),
  street: z.string().min( 1, `Street address is required` ),
  street2: z.string().optional(),
  city: z.string().min( 1, `City is required` ),
  state: z.string().min( 1, `State is required` ),
  zipCode: z
    .string()
    .min( 1, `ZIP code is required` )
    .regex( /^\d{5}$/, {
      message: `ZIP code must be 5 digits`
    })
})